import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, withModifiers as _withModifiers, createElementBlock as _createElementBlock, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "plan-content" }
const _hoisted_2 = { class: "table-wrapper" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("h4", null, " Documents on File/Pending Admin Review ", -1)
const _hoisted_4 = {
  key: 0,
  id: "update-personal-info-form",
  class: "form update-personal-info",
  method: "post"
}
const _hoisted_5 = { class: "d-flex gap-40 full-width align-items-end flex-column flex-md-row" }
const _hoisted_6 = { class: "action-buttons pdt-50 sm-pdr-0 sm-pdl-0 sm-pdt-20" }
const _hoisted_7 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Alerts = _resolveComponent("Alerts")!
  const _component_DataTable = _resolveComponent("DataTable")!
  const _component_SelectComponent = _resolveComponent("SelectComponent")!
  const _component_UploadFile = _resolveComponent("UploadFile")!
  const _component_DragDrop = _resolveComponent("DragDrop")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Alerts, { error: _ctx.error }, null, 8, ["error"]),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _hoisted_3,
        (_ctx.uploadedDocs.rows?.length)
          ? (_openBlock(), _createBlock(_component_DataTable, {
              key: 0,
              table: _ctx.uploadedDocs,
              classes: "striped small"
            }, null, 8, ["table"]))
          : _createCommentVNode("", true)
      ]),
      (!_ctx.existingPersonID)
        ? (_openBlock(), _createElementBlock("form", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createVNode(_component_SelectComponent, {
                label: "Document Type",
                selectedOption: _ctx.selectedDocType,
                "onUpdate:selectedOption": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.selectedDocType) = $event)),
                options: _ctx.documentTypes
              }, null, 8, ["selectedOption", "options"]),
              _createVNode(_component_UploadFile, {
                label: "Upload Files",
                multiple: false,
                onChange: _ctx.handleFileSelection,
                disabled: _ctx.loading,
                reset: _ctx.reset,
                onStop: _ctx.preventFileUpload
              }, null, 8, ["onChange", "disabled", "reset", "onStop"])
            ]),
            _createVNode(_component_DragDrop, {
              customClasses: "grey large w-10 full-width",
              onChange: _ctx.handleFileDrop,
              onStop: _ctx.preventFileUpload,
              reset: _ctx.reset,
              key: "drag-drop-personal-info",
              loading: _ctx.loading
            }, null, 8, ["onChange", "onStop", "reset", "loading"]),
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("button", {
                type: "button",
                class: "btn btn-secondary",
                onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.handleStep1 && _ctx.handleStep1(...args)))
              }, " Back "),
              _createElementVNode("button", {
                type: "button",
                class: "btn btn-primary",
                disabled: _ctx.loadingSubmit,
                onClick: _cache[2] || (_cache[2] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.handleSubmit && _ctx.handleSubmit(...args)), ["prevent"]))
              }, _toDisplayString(_ctx.loadingSubmit ? 'Saving...' : 'Save'), 9, _hoisted_7)
            ])
          ]))
        : _createCommentVNode("", true)
    ])
  ], 64))
}